import { useTranslation } from 'react-i18next';
import { Box } from '@react-three/drei';
import Markdown from 'react-markdown';
import EllieSays from './components/Ellie/EllieSays';
import { PillButton } from './components/buttons/PillButton';
import { useEffect, useRef, useState } from 'react';
import PopoverModal from './components/containers/PopoverModal';
import Plausible from 'plausible-tracker';
import { useAtom, useAtomValue } from 'jotai';
import { availableLanguagesAtom } from './atoms/content';
import { scormPreferedLanguage } from './atoms/auth';
import { MdLanguage } from "react-icons/md";
import styled from 'styled-components';
const Introduction = ({ scenarioId, delayInMS, visible, onIntroductionClose }: IntroductionProps) => {

	const { t } = useTranslation();
	const [open, setOpen] = useState(false);
	const { trackEvent } = Plausible();

	const delayTimeout = useRef<NodeJS.Timeout>();

	const [languages] = useAtom(availableLanguagesAtom);
	const preferedLanguage = useAtomValue(scormPreferedLanguage);
	const { i18n } = useTranslation();
	useEffect(() => {
		if (delayTimeout.current) clearTimeout(delayTimeout.current);
		if (delayInMS && visible) {
			delayTimeout.current = setTimeout(() => setOpen(true), delayInMS);
		}
	}, [visible, delayInMS]);

	const onClose = () => {
		trackEvent('start scenario', { props: { scenario: scenarioId } }, { domain: 'product2.tqwi.nl' });
		onIntroductionClose();
		setOpen(false);
	};

	const languageNames: { [key: string]: string } = {
		en: 'English',
		nl: 'Nederlands',
		fr: 'Français',
		de: 'Deutsch',
		es: 'Español',
		pt: 'Português',
		'zh-Hans': '简体中文',
	}

	return (
		<>
			{visible && open &&
				<PopoverModal title={t(`scenario.${scenarioId}.name`)} $scrollable>
					{!preferedLanguage &&
						<label style={{ fontWeight: 'bold', display: 'flex' }}>
							<MdLanguage style={{ height: '30px', width: '30px' }} />
							<Select style={{ marginInlineStart: '10px', border: 'none' }} value={i18n.language} onChange={e => i18n.changeLanguage(e.target.value)}>
								{languages && languages.map((lng) => {
									return <option value={lng}>{languageNames[lng]}</option>;
								})}
							</Select>
						</label>
					}
					<Box>
						<Markdown className='markdown'>
							{t(`scenario.${scenarioId}.description`)}
						</Markdown>
					</Box>
					<EllieSays>
						{t(`scenario.${scenarioId}.ellie_description`)}
					</EllieSays>

					<PillButton style={{ margin: 'auto' }} onClick={onClose}>{t('pages.selection.scenario_selected.start_button')}</PillButton>
				</PopoverModal>
			}
		</>
	);
};

// sc

const Select = styled.select`

	border-radius: 100em;
	padding-inline: 10px;

`

// types

type IntroductionProps = {
	scenarioId: string;
	delayInMS?: number;
	visible: boolean;
	onIntroductionClose: () => void;
};

export default Introduction;
